import * as React from 'react';
import { ExternalDialog } from './external-dialog';
var scriptMap = new Map();
var loadScript = function (src) {
    if (!scriptMap.has(src)) {
        var tag = document.createElement('script');
        var body = document.getElementsByTagName('body')[0];
        tag.type = 'text/javascript';
        tag.async = false; // Load in order
        tag.src = src;
        body.appendChild(tag);
        scriptMap.set(src, tag);
    }
    return scriptMap.get(src);
};
export var ExternalScripts = function (_a) {
    var externalJsPaths = _a.externalJsPaths;
    React.useEffect(function () {
        if (externalJsPaths && externalJsPaths.length) {
            externalJsPaths.map(function (script) { return loadScript(script); });
        }
    }, [externalJsPaths]);
    if (!(externalJsPaths && externalJsPaths.length)) {
        return null;
    }
    return (React.createElement(ExternalDialog, null));
};
//# sourceMappingURL=external-scripts.js.map